import { WarningAttachmentsCanNotBeDeleted } from 'owa-locstrings/lib/strings/warningattachmentscannotbedeleted.locstring.json';
import loc, { format } from 'owa-localize';
import { AttachmentInfoBarMessageId } from './AttachmentInfoBarMessageId';
import clearAttachmentInfoBarMessages from './clearAttachmentInfoBarMessages';
import { AttachmentState } from 'owa-attachment-full-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';

export const enum AttachmentDeleteFailureReason {
    GenericError,
}

export interface AttachmentDeleteItemFailure {
    item: AttachmentState;
    reason: AttachmentDeleteFailureReason;
}

function addMessageToInfoBar(
    infoMessageId: AttachmentInfoBarMessageId,
    message: string,
    infoBar: InfoBarHostViewState
) {
    addInfoBarMessage(infoBar, infoMessageId, [message]);
}

function showGenericErrorMessage(
    failure: AttachmentDeleteItemFailure,
    infoBar: InfoBarHostViewState
) {
    const attachment = getAttachment(failure.item.attachmentId);
    if (attachment) {
        const messageId = 'WarningAttachmentsCanNotBeDeleted';
        const message = format(loc(WarningAttachmentsCanNotBeDeleted), attachment.model.Name);

        addMessageToInfoBar(messageId, message, infoBar);
    }
}

export default function showErrorMessagesForDeleteFailure(
    failure: AttachmentDeleteItemFailure,
    infoBar: InfoBarHostViewState
): void {
    clearAttachmentInfoBarMessages(infoBar);
    showGenericErrorMessage(failure, infoBar);
}
